import TomSelect from './modules/TomSelect'

document.addEventListener("alpine:init", () => {
    Alpine.directive('tom-select', TomSelect).before('bind')
});